var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29.1 26.5",
    style: {
      enableBackground: "new 0 0 29.1 26.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#707070;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    transform: "translate(-1624.5 -163.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(1640 179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    className: "st0",
    d: "M5.7-11.5c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4l0,0C7.5-7.6,5.7-9.3,5.7-11.5z M-14.2-10.2H1.7 c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3h-15.9c-0.7,0-1.3,0.6-1.3,1.3S-14.9-10.2-14.2-10.2z M-6.2-6.2c-1.7,0-3.2,1.1-3.7,2.6 h-4.2c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3h4.2c0.7,2.1,3,3.2,5.1,2.4s3.2-3,2.4-5.1C-3-5.2-4.5-6.2-6.2-6.2L-6.2-6.2z  M12.3-3.6H1.7C1-3.6,0.4-3,0.4-2.3S1-0.9,1.7-0.9h10.6c0.7,0,1.3-0.6,1.3-1.3S13-3.6,12.3-3.6z M-3.6,5.7h-10.6 c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h10.6c0.7,0,1.3-0.6,1.3-1.3C-2.3,6.3-2.8,5.7-3.6,5.7L-3.6,5.7z M12.3,5.7H8.1 C7.4,3.6,5.1,2.5,3,3.3C1,4-0.1,6.3,0.6,8.3c0.7,2.1,3,3.2,5.1,2.4c1.1-0.4,2-1.3,2.4-2.4h4.2c0.7,0,1.3-0.6,1.3-1.3 C13.6,6.3,13,5.7,12.3,5.7L12.3,5.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.77ce65d0985e3a96518c8c93c35a33ea.svg";
export { ForwardRef as ReactComponent };